//register
export const START_GET_ACCOUNT_INFO = "START_GET_ACCOUNT_INFO";
export const GET_ACCOUNT_INFO_SUCCESS = "GET_ACCOUNT_INFO_SUCCESS";
export const GET_ACCOUNT_INFO_FAILED = "GET_ACCOUNT_INFO_FAILED";